document.addEventListener('DOMContentLoaded', () => {
    const marqueeContent = document.querySelector('.marquee-content');
    const originalContent = marqueeContent.innerHTML;
    
    // Function to check if we need more content
    const ensureEnoughContent = () => {
        const containerWidth = marqueeContent.parentElement.offsetWidth;
        const contentWidth = marqueeContent.scrollWidth;
        
        // If the content width is less than 3 times the container width, add more content
        if (contentWidth < containerWidth * 3) {
            marqueeContent.innerHTML += originalContent;
        }
    };
    
    // Initial check
    ensureEnoughContent();
    
    // Check periodically to ensure we always have enough content
    setInterval(ensureEnoughContent, 1000);
}); 